/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './EditRemoveComposition.scss';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import ModalAlert from '../../../ModalAlert';
import { deleteComposition } from '../../../../../actions/district';
import fetch from '../../../../../core/fetch';


const ModalConfirm = (props) => {
  return (
    <Modal {...props} >
      <Modal.Header className="bg-warning" closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.bodyText}
        <br /><br />
        <Button className="btn btn-default pull-right" onClick={props.onHide}>Anuluj</Button>
        <Button className="btn btn-warning pull-right" onClick={props.confirm}>OK</Button>
        <br /><br />
      </Modal.Body>
    </Modal>
  );
};

const fastStyleMargin = {
  marginTop: '7px',
};

const leftMargin = {
  marginLeft: '20px',
  marginTop: '7px',
}

const rightMargin = {
  marginRight: '15px',
}

class EditRemoveComposition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
      test: null
    }
  }

  dismissModal = () => this.setState({ showModal: false });

  edit = (v) => {
    this.props.editComposition(v);
  }

  delete = (v) => {
    this.props.deleteComposition(this.props.district.prefix, v.nazwa)
    .then((resp) => {
      this.setState({
        modalTitle: 'Status',
        modalBody: 'Pomyślnie usunięto kompozycję mapową.',
        showModal: true,
      });
    });
  }

  render() {
    return (
      <div className="col-xs-12"> 
        <h2>Edytuj/usuń kompozycję</h2>
        <p>Wybierz odpowiednią akcję dla wybranej kompozycji.</p>
        <table className="table">
          <thead>
            <tr>
              <th>Nazwa</th>
              <th className="text-center">Typ</th>
              <th className="text-center">Domyślna</th>
              <th className="text-center">Publiczny</th>
              <th className="text-center">Kategoria</th>
              <th className="fit">Akcje</th>
            </tr>
          </thead>
          <tbody>
            {this.props.district.compositions.map((v, i) => {
              return (
                <tr key={i}>
                  <td>{v.nazwa}</td>
                  <td className="text-center">{v.typ}</td>
                  <td className="text-center"><input name="r" type="checkbox" checked={v.isDefault} disabled/></td>
                  <td className="text-center"><input name="r" type="checkbox" checked disabled/></td>
                  <td className="text-center">{v.composition_type}</td>
                  <td className="fit">
                    <button type="button" className="btn btn-info" style={rightMargin} onClick={() => this.edit(v)}>Edytuj</button>
                    <button type="button" className="btn btn-danger" onClick={() => this.delete(v)}>Usuń</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          show={this.state.showModal}
          onHide={this.dismissModal}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  deleteComposition,
};

export default withStyles(s)(connect(mapState, mapDispatch)(EditRemoveComposition));



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/EditRemoveComposition/EditRemoveComposition.js